import React from "react";
import {cx} from "../../lib/ClassSet";
import {List} from "immutable";
import "./Item.css";
import format from 'date-fns/format';
import AddressInline from "../../components/AddressInline";
import {formatStatus} from "../../lib/TextFormatter";
import {AdminOnlyLink} from "../../components/shared/AdminOnlyLink";


export default function Item(props) {
  const {data} = props;

  const classes = cx({
    "item": true,
    "promo-code-list-item": true,
    "u-selected": props.selected,
    "u-inactive": List(["expired", "depleted"]).includes(data.get("status")),
  });

  // We want to display the address type only when it is not private
  const address = data.getIn(["recipient", "type"]) === "private"
    ? data.get("recipient").delete("type")
    : data.get("recipient");

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id f-open-details">{data.get("consignmentId")}</td>
      <td className="field f-id">{<AdminOnlyLink to={formatLink(data.get("extOrderId"))}>{data.get("extOrderId")}</AdminOnlyLink>}</td>
      <td className="field f-address"><AddressInline inline={false} address={address} /></td>
      <td className="field">{data.getIn(["recipient", "addressPostcode"])}</td>
      <td className="field f-status">{formatStatus(data.get("activitiesStatus"))}</td>
      <td className="field f-date">{formatDate(data.get("updatedAt"))}</td>
    </tr>
  )
}

function formatLink(extOrderId) {
  const orderId = extOrderId.split("-")[0];
  return `/shipping/orders/${orderId}`;
}

function formatDate(dateString) {
  return format(dateString, "MMM D, YYYY HH:mm")
}
